export default {"src":"/_next/static/media/twitter-share.d616b57b.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};